import { matchPath } from 'react-router-dom';

import type { OptionalAppRoute } from '../types';
import { doParamsAgree } from './doParamsAgree';

/** Every path a route claims, as a flat list. A route may declare several. */
const getClaimedPaths = (route?: OptionalAppRoute<any>): string[] => {
    const paths = Array.isArray(route?.path) ? route.path : [route?.path];

    return paths.filter(Boolean) as string[];
};

/**
 * Length of the longest URL the route matches as a prefix of the pathname, or -1 when it matches
 * nothing.
 *
 * Matching is prefix-based, so a route matches every deeper page under it. The length tells a
 * deeper match from a shorter one: a more specific route matches a longer URL.
 */
export const getMatchedUrlLength = (route: OptionalAppRoute<any> | undefined, pathname: string): number => {
    let longest = -1;

    for (const path of getClaimedPaths(route)) {
        const match = matchPath(pathname, { path });

        if (match && doParamsAgree(route, match.params)) {
            longest = Math.max(longest, match.url.length);
        }
    }

    return longest;
};
